module.exports = __webpack_public_path__ + "static/media/keo-hong-sam-daeong-500gr.8235ca2e.jpg";